import axios from "axios";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Detect the native Android WebView shell via the custom UA suffix (AstroFateApp/<version>).
const appMatch = (typeof navigator !== "undefined" ? navigator.userAgent : "").match(/AstroFateApp\/([\d.]+)/);
export const isAndroidApp = !!appMatch;
export const appVersion = appMatch ? appMatch[1] : "web";
const PLATFORM = isAndroidApp ? "android" : "web";

// Tag every backend call so server-side feature analytics + payments attribute app traffic correctly.
if (isAndroidApp) {
  axios.defaults.headers.common["X-Platform"] = "android";
  axios.defaults.headers.common["X-App-Version"] = appVersion;
  axios.defaults.headers.common["X-OS-Version"] = "android";
  axios.defaults.headers.common["X-Device-Model"] = "android-app";
}

const uuid = (storage, key) => {
  let id = storage.getItem(key);
  if (!id) { id = crypto.randomUUID(); storage.setItem(key, id); }
  return id;
};

export function trackAppEvent(name, screen = "home") {
  try {
    const installation = uuid(localStorage, "af_app_installation");
    const session = uuid(sessionStorage, "af_app_session");
    const events = [{ event_id: crypto.randomUUID(), name, screen }];
    if (!sessionStorage.getItem("af_app_open")) {
      events.unshift({ event_id: crypto.randomUUID(), name: "first_open", screen }, { event_id: crypto.randomUUID(), name: "app_open", screen });
      sessionStorage.setItem("af_app_open", "1");
    }
    axios.post(`${API}/mobile/events`, {
      installation_id: installation, session_id: session, platform: PLATFORM,
      app_version: appVersion, os_version: PLATFORM === "android" ? "android" : "browser",
      device_model: PLATFORM === "android" ? "android-app" : "browser", events,
    }).catch(() => {});
  } catch { /* Analytics must never interrupt a user workflow. */ }
}
